export enum EWebSocketMessageType {
    CONNECTION_PING = 'ping',
    CONNECTION_PONG = 'pong',
    CONNECTION_ERROR = 'error',
    NOTIFICATION = 'notification',
}
